// "Copy PGN / Download PGN / Copy FEN" for one finished game: in the replay's
// move list and under the result in the game-over dialog.
import { createCopyButton, createCrestButton, el } from '@bn-games/ui-shell';
import { t } from '../i18n/I18n.js';
import { downloadText, pgnFilename, recordFen, recordPgn } from '../history/exportGame.js';
import type { GameRecord } from '../history/types.js';

const PGN_MIME = 'application/x-chess-pgn';

export interface ExportRowOptions {
  /** The position "Copy FEN" gives; the game's final one by default (the replay passes the step on screen). */
  readonly fen?: () => string | null;
}

export function downloadRecordPgn(record: GameRecord): void {
  const pgn = recordPgn(record);
  if (pgn !== null) downloadText(pgnFilename(record), pgn, PGN_MIME);
}

export function createExportRow(record: GameRecord, opts: ExportRowOptions = {}): HTMLElement {
  const copied = t('exportGame.copied');
  const fen = opts.fen ?? ((): string | null => recordFen(record));
  return el('div', { class: 'chess-export', attrs: { role: 'group', 'aria-label': t('exportGame.label') } }, [
    createCopyButton({ label: t('exportGame.copyPgn'), copiedLabel: copied, getText: () => recordPgn(record) ?? '' }),
    createCrestButton({ label: t('exportGame.downloadPgn'), small: true, onClick: () => downloadRecordPgn(record) }),
    createCopyButton({ label: t('exportGame.copyFen'), copiedLabel: copied, getText: () => fen() ?? '' }),
  ]);
}
